import { axios, AxiosResponse } from '~/modules'
import { IAllergiesParams, IAllergy } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchAllergies = async (params: IAllergiesParams): Promise<IAllergy[]> => {
  const { patientId } = params
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/allergies`)
  const { data }: AxiosResponse<IAllergy[]> = response
  return data
}
